/** Telegram post with PvP tournament nominations (shared by Rewards CTA + leaderboard help). */
export const TOURNAMENT_NOMINATIONS_TELEGRAM_URL =
  "https://t.me/trix_pvp/29" as const
